import { actionGenerator } from '../../utils/redux/actionGenerator';

export const VALIDATE_GEO = 'filters/validate_geo' as const;

export const validateGeo = actionGenerator<typeof VALIDATE_GEO, string | null>(VALIDATE_GEO);

export type TValidateGeo = ReturnType<typeof validateGeo>;
